// extracted by mini-css-extract-plugin
module.exports = {"BorderPanel":"BorderLessPanel_BorderPanel__2atSy"};